










































































import { Component, Vue } from 'vue-property-decorator';
import { AccountProfileComponents } from '@/enums/AccountProfileComponents';
import { ElForm } from 'element-ui/types/form';
import { Action } from 'vuex-class';

interface RefsInterface {
    updateEmailForm: ElForm
}

interface Fields {
    email: string | null,
    emailCanonical: string | null,

    [key: string]: string | null
}

@Component({
    name: 'AccountProfileChangeEmail',
})
export default class AccountProfileChangeEmail extends Vue {
    public $refs!: Vue['$refs'] & RefsInterface;

    @Action('user/requestEmailReset') protected requestEmailReset!: (emailData: object) => Promise<unknown>;
    @Action('user/logoutUser') protected logoutUser!: () => void;

    protected updateEmailForm = {
        email: '',
        emailRepeat: '',
        hasAgreed: null,
    };

    protected isButtonEnabled = true;

    protected errorMessages: Fields = {
        email: null,
        emailCanonical: null,
    };

    protected toggleComponent(componentName: keyof typeof AccountProfileComponents) {
        this.$emit('toggle-component', AccountProfileComponents[componentName]);
    }

    protected submitForm(formName: keyof RefsInterface) {
        for (const key in this.errorMessages) {
            if (this.errorMessages.hasOwnProperty(key)) {
                this.errorMessages[key] = null;
            }
        }
        this.$refs[formName].validate(async (valid: boolean) => {
            if (valid) {
                this.isButtonEnabled = false;
                await this.requestEmailReset({
                    email: this.updateEmailForm.email,
                    emailRepeat: this.updateEmailForm.emailRepeat,
                }).then(() => {
                    this.$message.success(
                        'Email successfully changed, please check your inbox and verify your new address!');
                    this.logoutUser();
                    this.$router.push({name: 'Login'});
                }).catch((e) => {
                    e.response.data.errors.forEach((error: { detail: string, source: { pointer: string } }) => {
                        const pointerArray = error.source.pointer.split('/');
                        const pointer = pointerArray[pointerArray.length - 1];
                        this.errorMessages[pointer] = error.detail;
                    });
                    return new Error(e);
                }).finally(() => {
                    this.isButtonEnabled = true;
                });
            } else {
                return false;
            }
        });
    }

    protected cancelProfileDetails() {
        this.toggleComponent('Edit');
    }

    private validateEmail(rule: unknown, value: string, callback: (error?: Error) => {}) {
        if (value === '') {
            callback(new Error('Please input the new email'));
        } else if (value !== this.updateEmailForm.emailRepeat) {
            callback(new Error('Emails don\'t match!'));
        } else {
            callback();
        }
    }

    private validateEmailRepeat(rule: unknown, value: string, callback: (error?: Error) => {}) {
        if (value === '') {
            callback(new Error('Please input the email again'));
        } else if (value !== this.updateEmailForm.email) {
            callback(new Error('Emails don\'t match!'));
        } else {
            callback();
        }
    }
}
